import React, { PropsWithChildren } from 'react';
import './TabsContent.scss';
import classNames from 'classnames';

interface ITabsContentProps {
  isActive?: boolean;
  fullScreenMobile?: boolean;
  grayBackgroundMobile?: boolean;
}

export const TabsContent = ({ isActive, fullScreenMobile, grayBackgroundMobile, children }: PropsWithChildren<ITabsContentProps>): JSX.Element => {
  const fullClassName = classNames('tabs__content', { 'tabs__content--active': isActive, 'tabs__content--full-screen': fullScreenMobile, 'tabs__content--gray-bg': grayBackgroundMobile });
  return (
    <div className={fullClassName}>
      {children}
    </div>
  );
};
